'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const RenderHtml = ({ htmlData }) => {
    return (React__default['default'].createElement("div", { dangerouslySetInnerHTML: { __html: htmlData }, "data-testid": "render-html-container" }));
};

exports.RenderHtml = RenderHtml;
//# sourceMappingURL=RenderHtml-9d078fde.js.map
